// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html, body {\n  height: 100%;\n  width: 100%;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n.downloadPage {\n  background-color: white;\n  min-height: calc(100vh - 105px);\n  border: 10px solid transparent;\n  border-radius: 20px;\n  max-width: 850px;\n  margin: 0 auto;\n  padding: 10px;\n  padding-top: 0px;\n}\n\n.fullPage {\n  background-color: var(--background-color);\n  padding-top: 80px;\n  height: calc(100vh - 80px);\n  min-width: 380px;\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
